import { AlgoliaSearchParams } from "../../../../api/postCall/algoliaSearch";

export const recursivelyGeneratePayloadForInitialFetch = (
  filterPayload: AlgoliaSearchParams,
  batchNumber: number,
) => {
  const arraysFromBatchNumber = Array.from(
    { length: batchNumber + 1 },
    (_, index) => index,
  );
  return arraysFromBatchNumber.map((index) => ({
    ...filterPayload,
    page: index,
  }));
};
